import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment} from 'moment';

//const moment = _rollupMoment || _moment;
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    //dateInput: 'L',
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-indicadores-taquilla',
  templateUrl: './indicadores-taquilla.component.html',
  styleUrls: ['./indicadores-taquilla.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})

export class IndicadoresTaquillaComponent implements OnInit {
  errMsg:any;
  roles:any=[];
  prods:any=[];
  descs:any=[];
  cat:any=[];
  sisc:any=[];
  loading:boolean=false;
  fecIni:any = _moment().startOf("month");
  fecFin:any = _moment().endOf("month");
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]; 
  idDestinatario:number; 
  destinatario:any=[];
  trimestre:boolean=false;
  jefe:any=[];
  diario:any=[];
  dd:any;
  duplicar:boolean= false;
  metas:any=[];
  taqActs:number = 0;
  taqAdultos:number = 0;
  taqNinos:number = 0;  
  volActs:number = 0;
  volAdultos:number = 0;
  volNinos:number = 0;  
  desActs:number = 0;
  desAdultos:number = 0;
  desNinos:number = 0;  
  pedActs:number = 0;
  pedAdultos:number = 0;
  pedNinos:number = 0;  

  totActs:number = 0;
  totAdultos:number = 0;
  totNinos:number = 0;  
  totMetaActs:number = 0;
  totMetaAsis:number = 0;
  exps:any=[];
  
  thisForm = new FormGroup({
    trimestre: new FormControl(this.trimestre, []),
  });
  
  constructor(private dataService: DataService) {
   }

  ngOnInit() {
    this.loading = true;
    this.dataService.getVars("REP-DES").subscribe(
                      rows => {   
                              this.idDestinatario = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnIdDestinatarioCargado());
    this.dataService.getExposiciones("1").subscribe(
                      rows => {   
                              this.exps = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnExposicionesCargadas());                      
    this.dataService.getJefe().subscribe(
                      rows => {   
                              this.jefe = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnJefeCargado());

    this.dataService.getFormatoImp(43, 1).subscribe(
                          rows => {   
                                  this.formato = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnFormatoImpCargado());                      
    this.dataService.getCategorias().subscribe(
                      rows => {    
                              this.cat = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargadas());
  }

  fnExposicionesCargadas(){
    //console.log(this.exps);
    for(var e = 0; e < this.exps.length; e++){
      this.dataService.sisc(0, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.duplicar, true).subscribe(
                        rows => {   
                                this.sisc = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnSISCCargado());    

    }
  }
    
  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnIdDestinatarioCargado(){
    //console.log(this.idDestinatario);
    this.dataService.getDestinatario(this.idDestinatario).subscribe(
                      rows => {   
                              this.destinatario = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDestinatarioCargado());

  }

  fnDestinatarioCargado(){
    //console.log(this.destinatario);
  }

  fnJefeCargado(){
    //console.log(this.jefe);
  }

  fnCategoriasCargadas(){
    //console.log(this.cat);
    this.dataService.sisc(0, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.duplicar, true).subscribe(
                      rows => {   
                              this.sisc = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnSISCCargado());    
  }

  fnSISCCargado(){
    //console.log(this.sisc)
    this.totActs = 0;
    this.totAdultos = 0;
    this.totNinos = 0;
    for(var x = 0; x < this.sisc.length; x++){
      this.totActs += this.sisc[x].acts;
      this.totAdultos += this.sisc[x].ver_adultos;
      this.totNinos += this.sisc[x].ver_ninos;
      if(this.sisc[x].idGpo == 1){
        this.taqActs += this.sisc[x].acts;
        this.taqAdultos += this.sisc[x].ver_adultos;
        this.taqNinos += this.sisc[x].ver_ninos;
      }
      if(this.sisc[x].idGpo == 2){
        this.desActs += this.sisc[x].acts;
        this.desAdultos += this.sisc[x].ver_adultos;
        this.desNinos += this.sisc[x].ver_ninos;
      }
      if(this.sisc[x].idGpo == 3){
        this.volActs += this.sisc[x].acts;
        this.volAdultos += this.sisc[x].ver_adultos;
        this.volNinos += this.sisc[x].ver_ninos;
      }
      if(this.sisc[x].idGpo == 4){
        this.pedActs += this.sisc[x].acts;
        this.pedAdultos += this.sisc[x].ver_adultos;
        this.pedNinos += this.sisc[x].ver_ninos;
      }
    }

    this.dataService.getMeta(0, this.fecIni.format("YYYYMM"), this.trimestre).subscribe(
                      rows => {   
                              this.metas = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMetasCargadas()); 
  }


  fnMetasCargadas(){
    //console.log(this.metas);
    this.totMetaActs = 0;
    this.totMetaAsis = 0;

    for(var y = 0; y < this.metas.length; y++){
      this.totMetaActs += this.metas[y].metaAct;
      this.totMetaAsis += this.metas[y].metaAsis;
      this.metas[y].asis = 0;
      this.metas[y].acts = 0;
      this.metas[y].difAsis = this.metas[y].metaAsis * -1;
      this.metas[y].difActs = this.metas[y].metaAct * -1;

      for(var z = 0; z < this.sisc.length; z++){
        if(this.metas[y].grupo == this.sisc[z].grupo){
          this.metas[y].acts += this.sisc[z].acts;
          this.metas[y].asis += this.sisc[z].asis;
          this.metas[y].difActs +=  this.sisc[z].acts;
          this.metas[y].difAsis +=  this.sisc[z].asis;
        }
      }
    }

    this.loading = false;
  }

  fnDetallesCargados(){
    //console.log(this.diario);
    this.loading = false;
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.fecIni.value;
    ctrlValue.year(normalizedYear.year());
    this.fecIni.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    //console.log(this.fecIni);
    //console.log(normalizedMonth.format("YYYY/MM/DD"));
    this.fecIni = normalizedMonth;
    this.fecFin = _moment(this.fecIni).endOf("month");
    if(this.trimestre)
      this.fecFin = _moment(this.fecIni).add(2, "month").endOf("month");
    datepicker.close();
    this.dataService.sisc(0, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.duplicar, true).subscribe(
                      rows => {   
                              this.sisc = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnSISCCargado());
  }

  fnClickPeriodo(elem:any){
    setTimeout(() => {
      //console.log(elem);
      //console.log(this.thisForm.controls["trimestre"].value);
        if(this.thisForm.controls["trimestre"].value){
          this.trimestre = true;
          this.fecFin = _moment(this.fecIni).add(2, "month").endOf("month");

        }
        else{
          this.trimestre = false;
          this.fecFin = _moment(this.fecIni).endOf("month");
        }
        this.dataService.getCategorias().subscribe(
                      rows => {    
                              this.cat = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargadas());
    }, 10);
  }

  fnImprimeReporte(idFormato){
    //console.log("Imprime Reporte");
    this.dataService.insLog(43,'IMPRIMIR', "METAS TAQUILLA",'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato));              
  }

  fnElementosImpresionCargados(idFormato){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";
    var resAct = 0;
    var resAsis = 0;
    var justifica = "";

    var auxArea = this.dataService.findItemInObject(this.metas, 1, "idGpo")
    console.log(auxArea);

    resAct = auxArea.difActs;
    resAsis = auxArea.difAsis;
    if(resAct>0){
      justifica = "Se superó la meta en actividades";
      if(resAsis>0)
        justifica += " y afluencia"
      if(resAsis==0)
        justifica += " y se alcanzó la meta en afluencia"
      if(resAsis<0)
        justifica += " y no se alcanzó la meta en afluencia"
    }
    if(resAct==0){
      justifica = "Se alcanzó la meta en actividades"
      if(resAsis>0)
        justifica += " y se superó la meta en afluencia"
      if(resAsis==0)
        justifica += " y afluencia"
      if(resAsis<0)
        justifica += " y no se alcanzó la meta en afluencia"
    }
    if(resAct<0){
      justifica = "No se alcanzó la meta en actividades"
      if(resAsis>0)
        justifica += " y se superó la meta en afluencia"
      if(resAsis==0)
        justifica += " y se alcanzó la meta en afluencia"
      if(resAsis<0)
        justifica += " ni en afluencia"
    }

    var arrSpecialStrings = [{
      'DESTINATARIO': this.destinatario.length > 0 ? this.destinatario[0].nombre + " " + this.destinatario[0].apPat + " " + this.destinatario[0].apMat : null,
      'DESTINA_PUESTO': this.destinatario.length > 0 ? this.destinatario[0].puesto : null,
      'PERIODICIDAD': this.trimestre ? "trimestral" : "mensual",
      'PERIODO': this.trimestre ? this.dataService.fnGetDateFormat(this.fecIni.format("YYYY/MM/DD"), "TRIY") : this.dataService.fnGetDateFormat(this.fecIni.format("YYYY/MM/DD"), "MMY"),
      'NUMACTS': auxArea.acts,
      'NUMASIS': auxArea.asis > 0 ? this.dataService.fnFormatMoney(auxArea.asis).replace(".00","") : null,
      'NUMASI_LETRA': auxArea.asis > 0 ? this.dataService.fnLeeMonto(auxArea.asis).replace("PESOS (00/100) M.N.","") : null,
      'METAACTS': this.metas.length > 0 ? auxArea.metaAct + " actividad" + (auxArea.metaAct > 1 ? "es" : "") : null,
      'METAASIS': this.metas.length > 0 ? this.dataService.fnFormatMoney(auxArea.metaAsis).replace(".00","") : null,
      'RESACTS': (resAct > 0 ? "+" : "") + (resAct + " actividad" + (resAct != 1 ? "es" : "")),
      'RESASIS': (resAsis > 0 ? "+" : "") + (this.dataService.fnFormatMoney(resAsis).replace(".00","") + " asistente" + (resAsis != 1 ? "s" : "")),
      'JUSTIFICA': justifica,
      'JEFE_TAQ': this.jefe.length > 0 ? this.jefe[0].nombre : null
    }];
    console.log(arrSpecialStrings);
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: this.elemImp[i].style == "white" ? 0.01 : 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: 'letter',
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(this.dd).print();
    pdfMake.createPdf(this.dd).open();
  }


}